
import { Stack, Typography, Box, TextField } from '@mui/material';
import { useClient } from '../../../../context/ClientContext';
import ClientButton from '../../common/Clientbutton';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepsHeading from '../../common/StepsHeading';

export default function IsSymptomDescription({ userData, setUserData, onNext }) {
    const { theme,clientId } = useClient();
    const navigate = useNavigate();
    const [symptomValidationError, setSymtomValidationError] = useState("")
    const [experiencedSymptomsDec, setExperiencedSymptomsDec] = useState(() => {
        const isStoreSymptomDesc = localStorage.getItem('symptomDesc');
        if (isStoreSymptomDesc) {
            return isStoreSymptomDesc;
        }
        return "";
    });


    const handleNextStep = () => {
        if (experiencedSymptomsDec) {
            setSymtomValidationError("")
            localStorage.setItem('symptomDesc', experiencedSymptomsDec);
            navigate( `/${ clientId }-health-profile` );
            // navigate('/hellohealth-health-profile');
        } else {
            setSymtomValidationError("Please add symptom description")
        }

    };



    return (
        <Stack
            spacing={2}
            sx={{
                width: '100%',
                maxWidth: '100%',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
            }}
        >
            {/* <Typography
                sx={{
                    fontSize: { xs: '20px', sm: '23px', md: '26px' },
                    fontWeight: "700",
                    lineHeight: { xs: '24px', sm: '27px', md: '32px' },
                    textAlign: "center",
                    px: { xs: 1, sm: 4 },
                    width: '100%',
                    paddingTop: {
                        xs: "10px", sm: 1,
                    },
                    marginBottom: "10px"

                }}
            >Can you tell us more?</Typography> */}
            <StepsHeading title={"Can you tell us more?"} />
            <Stack sx={{ mt: 1, width: '100%', alignItems: 'center' }}>
                <Typography
                    sx={{
                        fontSize: {
                            xs: '14px',
                            sm: '14px',
                            md: '16px'
                        },
                        fontWeight: '400',
                        lineHeight: '18px',
                        textAlign: 'center'
                    }}
                >
                    In as much detail as you can,
                    please tell us about the symptoms
                    you've been experiencing.
                </Typography>

                <Box
                    sx={{
                        // width: '100%',
                        my: 2,
                        px: {
                            xs: 1,
                            sm: 2,
                            md: 2
                        }
                    }}
                >
                    <TextField
                        placeholder="I am not feeling well, I just don’t have energy. My sleep is interrupted, my mouth is dry. My body feels a bit inflamed, and I have trouble recovering after my workout."
                        multiline
                        minRows={2}
                        value={experiencedSymptomsDec}
                        onChange={(e) => setExperiencedSymptomsDec(e.target.value)}
                        error={symptomValidationError}
                        helperText={symptomValidationError}
                        sx={{
                            // Width: defined based on screen size
                            width: {
                                xs: '300px',
                                sm: '400px',
                                md: '500px',
                                lg: '500px',  // keeping consistent width for large screens
                            },

                            // OutlinedInput root styles
                            '& .MuiOutlinedInput-root': {
                                borderRadius: theme.inputFieldCSS.inputfiledBorderRadious || '12px',
                                transition: 'all 0.2s ease-in-out',
                                background: theme.inputFieldCSS.inputfiledBgColor,
                                height: {
                                    xs: '150px',
                                    sm: '225px',
                                    md: '225px',
                                },

                                // fieldset styles
                                '& fieldset': {
                                    border: `1px solid ${theme.inputFieldCSS.inpurFieldBorderColor}`,
                                },

                                // border on hover 
                                '&:hover fieldset': {
                                    border: `1px solid ${theme.inputFieldCSS.inpuFieldBorderColorOhHover}`,
                                },

                                // border on focus 
                                '&.Mui-focused fieldset': {
                                    border: `1px solid ${theme.inputFieldCSS.inpurFieldBorderColorOnFocus}`,
                                },

                                // Change background color on focus
                                '&.Mui-focused': {
                                    backgroundColor: theme.inputFieldCSS.inputfiledBgColorOnFocus, // or use theme value
                                },
                            },

                            // Input base styles
                            '& .MuiInputBase-input': {
                                height: {
                                    xs: '120px !important',
                                    sm: '195px !important',
                                    md: '190px !important',
                                },
                                padding: {
                                    xs: '5px',
                                    sm: '16px',
                                    md: '16px',
                                },
                                fontSize: {
                                    xs: '14px',
                                    sm: '16px',
                                    md: '16px',
                                },
                                lineHeight: '1.5',
                                color: theme.inputFieldCSS.inputfiledTextColor,

                                // Placeholder styling
                                '&::placeholder': {
                                    color: theme.inputFieldCSS.inputFieldPlaceholderColor,
                                    fontSize: { xs: '14px', sm: "16px", lg: "18px" },
                                    fontWeight: 500,

                                    // opacity: 0.8,
                                },
                            },
                        }}
                    />

                </Box>
                <ClientButton
                    text="Next"
                    onClick={handleNextStep}
                    backgroundColor={theme.primaryColor}
                    sx={{
                        maxWidth: "320px",
                        width: "100%",
                        marginTop: { xs: '4px', sm: '30px', md: '20px', lg: "20px" },
                    }}
                />
            </Stack>
        </Stack>
    );
}